var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9285 9.0625H5.34499C5.52526 6.46984 6.42695 4.36722 7.3211 2.87698C7.46886 2.6307 7.61671 2.40062 7.7615 2.18727C4.65316 3.07621 2.30677 5.77001 1.9285 9.0625ZM5.345 10.9375H1.9285C2.30677 14.23 4.65322 16.9239 7.76161 17.8127C7.6168 17.5994 7.4689 17.3693 7.3211 17.1229C6.42696 15.6326 5.52529 13.5301 5.345 10.9375ZM7.22533 10.9375H12.7746C12.599 13.1069 11.8387 14.8789 11.0711 16.1583C10.6883 16.7963 10.3062 17.3071 10 17.6777C9.69376 17.3071 9.31171 16.7963 8.9289 16.1583C8.16132 14.8789 7.40099 13.1069 7.22533 10.9375ZM12.7747 9.0625H7.22531C7.40096 6.89307 8.16131 5.12096 8.9289 3.84165C9.31171 3.20364 9.69376 2.69269 10 2.32212C10.3062 2.69269 10.6883 3.20364 11.0711 3.84165C11.8387 5.12096 12.599 6.89307 12.7747 9.0625ZM14.655 10.9375C14.4747 13.5301 13.573 15.6326 12.6789 17.1229C12.5311 17.3693 12.3832 17.5994 12.2384 17.8127C15.3468 16.9239 17.6933 14.23 18.0715 10.9375H14.655ZM18.0715 9.0625H14.655C14.4747 6.46984 13.573 4.36722 12.6789 2.87698C12.5311 2.6307 12.3833 2.40062 12.2385 2.18726C15.3469 3.0762 17.6933 5.77001 18.0715 9.0625ZM10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalIcon);
export default __webpack_public_path__ + "static/media/global-icon.d87f2a9504da16b2f956a5f6446d1f80.svg";
export { ForwardRef as ReactComponent };